import { trackOrientation } from '@leprecoins/effector';
import { createEvent } from 'effector';

const setup = createEvent();

export const orientation = Object.assign(trackOrientation({ setup }), { setup });
